<template>
<div>
  
  <div v-html="content">
  </div>
  <div class="button-area">
    <van-button type="default" size="normal" @click="refused"> 拒 绝 </van-button>
    <van-button 
      :type="confirmType"
      :disabled="confirmDisabled"
      size="normal"
      class="acceptProtocol"
      :style="{color: totalTime > 0 ? '#ffffff' : 'white'}"
      @click="accept"> {{acceptStr}} </van-button>
  </div>
</div>
</template>

<script>
import api from '@/fetch/api';
import steamApi from '@/fetch/steamApi'
import { Toast } from 'vant';
import {
  Dialog
} from 'vant'

export default {
  data() {
    return {
      acceptStr: "10秒",
      totalTime: 10,
      confirmType: "default",
      confirmDisabled: true,
      xyState: "00",
      sysVersion:"OLD",
      content:"",
    };
  },
  mounted() {
    let clock = window.setInterval(() => {
      this.totalTime--
      this.acceptStr = this.totalTime + '秒'
      if (this.totalTime == 0) {
        window.clearInterval(clock)
        this.confirmDisabled = false;
        this.acceptStr = '接受';
        this.confirmType = 'info';
      }
    }, 1000)

  },
  created: function() {
    document.title = "槽车蒸洗入库须知";
    this.getsysBcInfo("steamxy");
  },
  methods: {
    refused() {
      var that = this;
      Dialog.alert({
        message: '您未确认安全告知书，无法进行预约',
      }).then(() => {
        that.$router.push({
          name: 'index'
        })
      });
    },
    accept() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      if(openid) {
         var formData = new FormData();
        formData.append('openid',openid);
        steamApi.hasSteamAppointmentenable(formData).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            if(res.data.hasAppointment)
            {
              Dialog({
                message: '您有尚未处理的预约，请先处理您的预约'
              });
              return;
            }
            else{
              that.$router.push({
              name: 'steamAddAppointment'
            })
            }
          }
          else{
            Toast.fail(res.message);
          }
        }).catch(function() {
          Toast.fail('连接失败，请刷新页面');
        });
      }
      // api.confirmxybyopenid(openid,'steam').then(function(resData) {
      //   var res = JSON.parse(resData);
      //   if (res.respCode == "0") {
      //     that.$router.push({
      //       name: 'steamCleanHome',
      //     });
      //   } else {
      //     Dialog.alert({
      //       message: res.message,
      //     }).then(() => {

      //     });
      //   }
      // });
    },

    //获取系统信息
    getsysBcInfo(type)
    {
      var that = this;
      //获取系统信息
      api.getsysBcInfo(type).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var content = res.data;
          that.content = content;
        }
      }).catch(function() {
        //Toast.fail('连接失败，请刷新页面');
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
    padding: 1rem 0.825rem 0;
    p {
        line-height: 2;
        vertical-align: baseline;
        span {
            font-size: 12px;
        }
    }
}

.button-area {
    margin: 1rem;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
        width: 50%;
        text-align: center;
        margin: 0 auto;
    }
    .acceptProtocol {
        background: #316892;
    }
}
</style>
